<template>
  <main class="home">
    <Banner />
    <section class="home__intro" id="nossahistoria">
      <img src="../assets/img/intro.jpg" alt="" />
      <div class="home__intro__text">
        <div class="container container--small">
          <div class="home__intro__text__banner">
            <dfp-slot
              path="/118650305/patrocinados/jbs"
              :size="[300, 250]"
              id="div-gpt-ad-1664301576445-0"
              class="desktop"
            />
          </div>
          <div>
            <p>
              O <strong>Estadão</strong> e a <strong>JBS</strong> se reuniram
              para criar uma experiência virtual que conta a história da
              alimentação e da proteína nas últimas décadas no Brasil e no
              mundo. A partir do relato de especialistas no assunto, foi feita
              uma ampla pesquisa no acervo do jornal e da empresa para contar
              essa trajetória com base em fatos marcantes que impactaram a
              economia e o comportamento das pessoas.
            </p>

            <p>
              Esse conteúdo especial foi criado em comemoração dos 70 anos de
              história da <strong>JBS</strong>, completados em 2023. Confira as
              mudanças de hábitos na alimentação no mundo e também a
              transformação da empresa, que começou como um pequeno açougue em
              Anápolis, Goiás, e hoje está presente em mais de 20 países,
              empregando mais de 270 mil colaboradores no mundo, sendo 152 mil
              no Brasil.
            </p>

            <p>Bom passeio!</p>
            <a href="#1953"></a>
          </div>
        </div>
      </div>
    </section>
    <Formato1953 ano="1953" />
    <Formato1957 ano="1957" />
    <Formato1970 ano="1970" />
    <Formato1980 ano="1980" />
    <Formato1988 ano="1988" />
    <Formato1993 ano="1993" />
    <Formato1996 ano="1996" />
    <Formato1997 ano="1997" />
    <Formato1999 ano="1999" />
    <Formato2004 ano="2004" />
    <Formato2005 ano="2005" />
    <Formato2007 ano="2007" />
    <Formato2008 ano="2008" />
    <Formato2009 ano="2009" />
    <Formato2010 ano="2010" />
    <Formato2011 ano="2011" />
    <Formato2012 ano="2012" />
    <Formato2013 ano="2013" />
    <Formato2014 ano="2014" />
    <Formato2015 ano="2015" />
    <Formato2019 ano="2019" />
    <Formato2020 ano="2020" />
    <Formato2021 ano="2021" />
    <Formato2022 ano="2022" />
    <Formato2023 ano="2023" />
    <Final />
    <Loading />
  </main>
</template>

<script>
import Banner from '@/components/Banner.vue';
import Formato1953 from '@/components/Formato1953.vue';
import Formato1957 from '@/components/Formato1957.vue';
import Formato1970 from '@/components/Formato1970.vue';
import Formato1980 from '@/components/Formato1980.vue';
import Formato1988 from '@/components/Formato1988.vue';
import Formato1993 from '@/components/Formato1993.vue';
import Formato1996 from '@/components/Formato1996.vue';
import Formato1997 from '@/components/Formato1997.vue';
import Formato1999 from '@/components/Formato1999.vue';
import Formato2004 from '@/components/Formato2004.vue';
import Formato2005 from '@/components/Formato2005.vue';
import Formato2007 from '@/components/Formato2007.vue';
import Formato2008 from '@/components/Formato2008.vue';
import Formato2009 from '@/components/Formato2009.vue';
import Formato2010 from '@/components/Formato2010.vue';
import Formato2011 from '@/components/Formato2011.vue';
import Formato2012 from '@/components/Formato2012.vue';
import Formato2013 from '@/components/Formato2013.vue';
import Formato2014 from '@/components/Formato2014.vue';
import Formato2015 from '@/components/Formato2015.vue';
import Formato2019 from '@/components/Formato2019.vue';
import Formato2020 from '@/components/Formato2020.vue';
import Formato2021 from '@/components/Formato2021.vue';
import Formato2022 from '@/components/Formato2022.vue';
import Formato2023 from '@/components/Formato2023.vue';
import Final from '@/components/Final.vue';
import Loading from '@/components/Loading.vue';
import DfpSlot from '@/components/DfpSlot.vue';

export default {
  components: {
    Banner,
    Formato1953,
    Formato1957,
    Formato1970,
    Formato1980,
    Formato1988,
    Formato1993,
    Formato1996,
    Formato1997,
    Formato1999,
    Formato2004,
    Formato2005,
    Formato2007,
    Formato2008,
    Formato2009,
    Formato2010,
    Formato2011,
    Formato2012,
    Formato2013,
    Formato2014,
    Formato2015,
    Formato2019,
    Formato2020,
    Formato2021,
    Formato2022,
    Formato2023,
    Final,
    Loading,
    DfpSlot,
  },

  methods: {
    numberAnimation(event) {
      //console.log(window.pageYOffset);
      let anos = document.querySelectorAll('.ano');
      anos.forEach((ano) => {
        let start = ano.offsetTop;
        let end = ano.offsetHeight + ano.offsetTop;
        if (window.pageYOffset > start && window.pageYOffset <= end) {
          let h2 = ano.querySelector('h2');
          let current = window.pageYOffset - start;
          let max = current / window.innerHeight;
          let translate = current + (window.innerHeight * 3) / 4;
          if (screen.width > 760) {
            if (1 - max > 0.14) {
              h2.style.transform = `scale(${1 - max})`;
            }
          } else {
            if (1 - max > 0.33) {
              h2.style.transform = `scale(${1 - max})`;
            }
          }
        }
      });
    },
  },
  created() {
    window.addEventListener('scroll', this.numberAnimation);
  },
};
</script>

<style scoped lang="scss">
.home {
  &__intro {
    position: relative;
    background: color(cBlue5);

    img {
      width: 100%;
      height: 100vh;
      object-fit: cover;
      min-height: 720px;
      margin: -4px 0;
      @include media('<=desktop') {
        min-height: 1230px;
      }
    }
    &__text {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 100%;
      @include media('<=desktop') {
        padding: 40px 20px;
      }
      &__banner {
        float: right;
        margin-left: 20px;
        @include media('<=desktop') {
          float: initial;
          text-align: center;
          margin: 30px 0;
        }
      }
      .container {
        max-width: 711px;
      }
      p {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.84375rem;
        margin-bottom: 1.5rem;
        text-align: center;
      }
      a {
        display: block;
        margin: 0 auto;
        width: 30px;
        &:hover {
          &:after {
            color: color(cGreen);
          }
        }

        &::after {
          content: '\e900';
          font-family: 'icomoon' !important;
          display: inline-block;
          font-size: 5rem;
          color: color(cBlue);
          transition: 0.3s ease-in-out;
        }
      }
    }
  }
}
</style>
